import { combineReducers } from "redux";
import walkReducer from './walkReducer'
import logInReducer from './logInReducer'
import mapReducer from './mapReducer'
import errorReducer from "./errorReducer";
import friendReducer from "./friendReducer"
import chatReducer from "./chatReducer";
import alertReducer from "./alertReducer";
import noticeReducer from "./noticeReducer";
import profileReducer from "./profileReducer";
import talkReducer from "./talkReducer";
import pageListenerReducer from "./pageListenerReducer";
import talkRoomReducer from "./talkRoomReducer";
import noteReducer from "./notesReducers"
import currentWalkReducer from "./currentWalkReducer";
import noteListenerReducer from "./noteListenerReducer";
import previewReducer from "./previewReducer";
import myWalkFilterReducer from './myWalkFilterReducer'
import TeamFilterReducer from "./setFilterTeamArrReducer";
import removeWalkReducer from "./removeWalkReducer";
import reportReducer from "./reportReducer";
import proReducer from "./proReducer";
import messageReducer from "./messageReducer";
import stepReducer from "./stepReducer";

export const rootReducer = combineReducers({
  chat: chatReducer, 
  errors: errorReducer,
  walks: walkReducer,
  logIn: logInReducer,
  map: mapReducer,
  friends: friendReducer,
  alert: alertReducer,
  notice: noticeReducer,
  profile: profileReducer,
  talkOpen: talkReducer,
  pageListener: pageListenerReducer,
  talkRoom: talkRoomReducer,
  notes: noteReducer,
  currentWalk: currentWalkReducer,
  noteListener: noteListenerReducer,
  preview: previewReducer,
  myWalkFilter: myWalkFilterReducer,
  teamFilter: TeamFilterReducer,
  removeWalk: removeWalkReducer,
  report: reportReducer,
  store: proReducer,
  unread: messageReducer,
  steps: stepReducer
});

export type RootState = ReturnType<typeof rootReducer>